import { render, staticRenderFns } from "./rm-select.vue?vue&type=template&id=bbabfa86&scoped=true&"
import script from "./rm-select.vue?vue&type=script&lang=js&"
export * from "./rm-select.vue?vue&type=script&lang=js&"
import style0 from "./rm-select.vue?vue&type=style&index=0&id=bbabfa86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbabfa86",
  null
  
)

export default component.exports